import { TranslationKey } from '../../components/ProductCard/i18n';
import { VerticalType } from '../../types/cmsTypes';

// Offer-group label keys by vertical, shared by the product card and the PDP Offers section (CMS-2032).

const APPLY_THROUGH_MAP: Partial<Record<VerticalType, TranslationKey>> = {
  PERSONAL_LOANS: 'apply_through',
  CREDIT_CARD: 'apply_through',
  BANKING: 'apply_through_stk_bka',
  INVESTMENTS: 'apply_through_stk_bka',
  INSURANCE: 'apply_through',
  TRAVEL_INSURANCE: 'purchase_through',
  CAR_INSURANCE: 'apply_through_ci',
};

const TITLE_WELCOME_OFFER_MAP: Partial<Record<VerticalType, TranslationKey>> = {
  PERSONAL_LOANS: 'sta_bka_bank_gift',
  BANKING: 'sta_bka_bank_gift',
  INVESTMENTS: 'sta_bka_bank_gift',
  TRAVEL_INSURANCE: 'sta_bka_bank_gift',
  CAR_INSURANCE: 'sta_bka_bank_gift',
  CREDIT_CARD: 'bank_gift',
  INSURANCE: 'bank_gift',
};

// Who grants the welcome gift: the provider on these verticals, the bank elsewhere.
const WELCOME_GIFT_INFO_MAP: Partial<Record<VerticalType, TranslationKey>> = {
  PERSONAL_LOANS: 'provider_gift_info',
  BANKING: 'provider_gift_info',
  INVESTMENTS: 'provider_gift_info',
  TRAVEL_INSURANCE: 'provider_gift_info',
  CAR_INSURANCE: 'provider_gift_info',
};

/** Lead-in of the choose-one group ("Apply through … and choose from :count …"). */
export function getApplyThrough(vertical: VerticalType): TranslationKey {
  return APPLY_THROUGH_MAP[vertical] ?? 'apply_through';
}

/** Heading of the welcome-offer group; the bank by default, like its lead-in. */
export function getTitleWelcomeOffer(vertical: VerticalType): TranslationKey {
  return TITLE_WELCOME_OFFER_MAP[vertical] ?? 'bank_gift';
}

/** Lead-in of the welcome-offer group. */
export function getWelcomeGiftInfo(vertical: VerticalType): TranslationKey {
  return WELCOME_GIFT_INFO_MAP[vertical] ?? 'bank_gift_info';
}

/** Travel insurance shows the offer groups without their lead-in lines. */
export function hasOfferGroupLeadIn(vertical?: VerticalType): boolean {
  return vertical !== 'TRAVEL_INSURANCE';
}
